import * as api from '@owl-nest/api-client/latest'
import * as model from '@owl-nest/models'

export const extraFields = [
  'account',
  'analytics',
  'answer_code',
  'billing',
  'default_manager',
  'examples',
  'fields_needed',
  'fieldsets',
  'latest_news',
  'latest_supporter',
  'links',
  'manager',
  'onboarding_steps',
  'owner.stats',
  'partnerships',
  'proposal',
  'rewards',
  'sponsorships.channel',
  'sponsorships',
  'shippings',
  'tags',
  'tax_receipts_available',
  'thread',
  'unread_count',
  'user_orders',
  'user_role',
  'user_subscriptions',
] as const

export type ExtraFields = (typeof extraFields)[number]

export type Project = api.Project<ExtraFields>

export type UpdateProject = api.UpdateProject<ExtraFields>

export function redirectToComingSoon(project: Project): boolean {
  const userPermissions = project.permissions.self

  return !userPermissions?.includes(api.ProjectSelfPermission.READ) && model.project.isComingSoonEnabled(project)
}

export function redirectToForbidden(project: Project): boolean {
  if (project.status === api.ProjectStatus.ONLINE) {
    return false
  }

  const userPermissions = project.permissions.self
  return !userPermissions?.includes(api.ProjectSelfPermission.READ)
}
